import React from 'react'
import { csx, Flex, IconWarningCircle, Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'

export const ProductSkuAvailabilityNotAvailable = () => {
  return (
    <Flex
      direction="column"
      justify="space-around"
      align="center"
      className={csx({ paddingY: '$space-16' })}
    >
      <IconWarningCircle
        className={csx({ color: '$orange40', marginBottom: '$space-2' })}
      />
      <Text
        tone="warning"
        variant="action1"
        className={csx({ marginBottom: '$space-2' })}
      >
        <FormattedMessage id="checkout.unavailable-product" />
      </Text>
      <Text
        tone="secondary"
        className={csx({ marginX: '$space-7', textAlign: 'center' })}
      >
        <FormattedMessage id="checkout.unavailable-product.message" />
      </Text>
    </Flex>
  )
}
